var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 5,
    fill: "#F3F6F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4139_30990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4532 15.0642C25.2899 13.1697 22.6439 9.99124 17.9999 9.99124C13.3559 9.99124 10.7099 13.1697 9.54667 15.0642C9.18706 15.6459 8.99658 16.3162 8.99658 17C8.99658 17.6838 9.18706 18.3541 9.54667 18.9357C10.7099 20.8302 13.3559 24.0087 17.9999 24.0087C22.6439 24.0087 25.2899 20.8302 26.4532 18.9357C26.8128 18.3541 27.0033 17.6838 27.0033 17C27.0033 16.3162 26.8128 15.6459 26.4532 15.0642ZM25.1744 18.1505C24.1754 19.775 21.9142 22.5087 17.9999 22.5087C14.0857 22.5087 11.8244 19.775 10.8254 18.1505C10.6118 17.8048 10.4986 17.4064 10.4986 17C10.4986 16.5936 10.6118 16.1952 10.8254 15.8495C11.8244 14.225 14.0857 11.4912 17.9999 11.4912C21.9142 11.4912 24.1754 14.222 25.1744 15.8495C25.3881 16.1952 25.5012 16.5936 25.5012 17C25.5012 17.4064 25.3881 17.8048 25.1744 18.1505Z",
    fill: "#0199B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 13.25C17.2583 13.25 16.5333 13.4699 15.9166 13.882C15.2999 14.294 14.8193 14.8797 14.5355 15.5649C14.2516 16.2502 14.1774 17.0042 14.3221 17.7316C14.4668 18.459 14.8239 19.1272 15.3484 19.6517C15.8728 20.1761 16.541 20.5333 17.2684 20.6779C17.9958 20.8226 18.7498 20.7484 19.4351 20.4645C20.1203 20.1807 20.706 19.7001 21.118 19.0834C21.5301 18.4667 21.75 17.7417 21.75 17C21.7488 16.0058 21.3533 15.0527 20.6503 14.3497C19.9473 13.6467 18.9942 13.2512 18 13.25ZM18 19.25C17.555 19.25 17.12 19.118 16.75 18.8708C16.38 18.6236 16.0916 18.2722 15.9213 17.861C15.751 17.4499 15.7064 16.9975 15.7932 16.561C15.8801 16.1246 16.0943 15.7237 16.409 15.409C16.7237 15.0943 17.1246 14.88 17.561 14.7932C17.9975 14.7064 18.4499 14.751 18.861 14.9213C19.2722 15.0916 19.6236 15.38 19.8708 15.75C20.118 16.12 20.25 16.555 20.25 17C20.25 17.5967 20.0129 18.169 19.591 18.591C19.169 19.0129 18.5967 19.25 18 19.25Z",
    fill: "#0199B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4139_30990"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(9 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowUser);
export default __webpack_public_path__ + "static/media/show-user.50da6626c162d1d48cc210d7977fb279.svg";
export { ForwardRef as ReactComponent };